import { inject, provideAppInitializer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

const HUBSPOT_ICON_SVG =
  '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">' +
  '<path fill="currentColor" d="M23.2 11.21V7.88c.88-.42 1.48-1.29 1.48-2.31V5.5c0-1.41-1.15-2.56-2.56-2.56h-.07c-1.41 0-2.56 1.15-2.56 2.56v.07c0 1.02.6 1.9 1.46 2.31h.02v3.34c-1.33.2-2.5.74-3.47 1.53h.01L8.37 5.63c.06-.22.1-.47.11-.73 0-1.6-1.29-2.89-2.89-2.89S2.7 3.3 2.7 4.9a2.89 2.89 0 0 0 2.88 2.89c.53 0 1.02-.15 1.44-.4h-.01l8.99 7c-.76 1.13-1.21 2.53-1.21 4.03s.5 3.03 1.35 4.22l-.02-.02-2.78 2.73c-.18-.05-.38-.08-.59-.08-1.31 0-2.37 1.06-2.37 2.37s1.06 2.37 2.37 2.37 2.37-1.06 2.37-2.37v-.03c0-.24-.05-.47-.12-.69v.02l2.67-2.66c1.2.9 2.72 1.45 4.36 1.45 4.03 0 7.3-3.27 7.3-7.3a7.29 7.29 0 0 0-6.06-7.19h-.04Zm-1.12 10.95c-2.07 0-3.75-1.68-3.75-3.75s1.68-3.75 3.75-3.75 3.75 1.68 3.75 3.75c0 2.08-1.68 3.75-3.74 3.75Z"></path>' +
  '</svg>';

/**
 * Registry of custom (non-Material) svg icons used across the app, keyed by the
 * name passed to `<mat-icon svgIcon="...">`.
 *
 * Add new entries here as needed - `provideCustomIcons()` registers all of them
 * once at app bootstrap.
 */
const CUSTOM_ICONS: Record<string, string> = {
  hubspot: HUBSPOT_ICON_SVG,
};

/**
 * App-wide provider that registers all custom svg icons (see `CUSTOM_ICONS`)
 * with Angular Material's icon registry. Add this once to the app's bootstrap
 * providers; any component can then use `<mat-icon svgIcon="hubspot">` (or any
 * other registered name) without knowing about the registration.
 */
export function provideCustomIcons() {
  return provideAppInitializer(() => {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    for (const [name, svg] of Object.entries(CUSTOM_ICONS)) {
      iconRegistry.addSvgIconLiteral(name, sanitizer.bypassSecurityTrustHtml(svg));
    }
  });
}
